



























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { AxiosRequestConfig } from 'axios';
import { FILE_UPLOAD } from '@/common/api';

type WithMessage<T extends Record<string, any>> = T & {
  message: string;
}

const defaultFormData: WithMessage<Orders.HuntingLicenseCore> = {
  licenseDate: '',
  series: '',
  number: '',
  message: '',
};

// eslint-disable-next-line no-use-before-define
@Component<HuntingLicenseForm>({
  name: 'HuntingLicenseForm',
})
export default class HuntingLicenseForm extends Vue {
  @Prop({ required: true, type: Boolean })
  show!: boolean;

  @Watch('show')
  toggleOpen(val): void {
    if (val) {
      this.open();
    } else {
      this.close();
    }
  }

  epguMessageDescription = 'В момент выдачи разрешения гражданину в его ЛГ ЕПГУ будет '
    + 'направлено сообщение о том что работы по его электронному заявлению завершены. ' +
    'Так же ему будет передано сообщение ниже. Где вы можете назначить гражданину время ' +
    'приема для получения разрешения, адрес, номер кабинета, итд.';

  formData: WithMessage<Orders.HuntingLicenseCore> = { ...defaultFormData };

  visible: boolean = false;

  $refs!: {
    formData: any;
  };

  title: string = 'Выдача разрешения';

  async save(): Promise<void> {
    const isValid = await this.$refs.formData.validate();
    if (!isValid) return;
    this.$emit('saved', this.formData);
  }

  open(): void {
    this.visible = true;
    this.clearForm();
  }

  close(): void {
    this.visible = false;
    this.$emit('update:show', this.visible);
  }

  clearForm() {
    this.formData = { ...defaultFormData };
  }

  beforeDestroy() {
    this.visible = false;
  }
}
